import { createContext, useContext, useMemo, useState } from "react";

const ReturnExchangesValueContext = createContext();
const ReturnExchangesActionsContext = createContext();

export function ReturnExchangesContextProvider({ children }) {
    const [returnExchanges, setReturnExchanges] = useState([]);
    const [pagination, setPagination] = useState({
        page: null,
        pageSize: null,
        hasNext: null,
        hasPrev: null,
        totalCount: null,
        totalPage: null,
        nextPage: null,
        prevPage: null,
    });

    const returnExchangesActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setReturnExchanges(newValues);
                },
                setValue: setReturnExchanges
            }
        },
        []
    )

    const paginationActions = useMemo(
        () => {
            return {
                onSet(newValues) {
                    setPagination(newValues);
                },
                setValue: setPagination
            }
        },
        []
    )

    return (
        <>
            <ReturnExchangesActionsContext.Provider value={{ returnExchanges: returnExchangesActions, pagination: paginationActions }}>
                <ReturnExchangesValueContext.Provider value={{ returnExchanges, pagination }}>
                    {children}
                </ReturnExchangesValueContext.Provider>
            </ReturnExchangesActionsContext.Provider>
        </>
    );
}

export function useReturnExchangesValueContextHook(props) {
    const value = useContext(ReturnExchangesValueContext);

    if (value === undefined) {
        throw new Error('useReturnExchangesValueContextHook should be used within ReturnExchangesValueContext');
    }

    return {
        returnExchanges: value.returnExchanges,
        pagination: {
            page: value.pagination?.page,
            pageSize: value.pagination?.pageSize,
            hasNext: value.pagination?.hasNext,
            hasPrev: value.pagination?.hasPrev,
            totalCount: value.pagination?.totalCount,
            totalPage: value.pagination?.totalPage,
            nextPage: value.pagination?.nextPage,
            prevPage: value.pagination?.prevPage,
        }
    };
}

export function useReturnExchangesActionsContextHook(props) {
    const value = useContext(ReturnExchangesActionsContext);

    if (value === undefined) {
        throw new Error('useReturnExchangesActionsContextHook should be used within ReturnExchangesActionsContext');
    }

    return {
        returnExchanges: {
            onSet: value.returnExchanges.onSet,
            setValue: value.returnExchanges.setValue
        },
        pagination: {
            onSet: value.pagination.onSet,
            setValue: value.pagination.setValue
        }
    };
}